import React, { Component} from 'react';
import {connect} from 'react-redux';

class Indent extends Component {
	constructor(props){
		super(props);
	}
	componentDidMount(){
		const { dispatch } = this.props;
	}
	render() {
		return (
			<div className = "root">
                <div className = "banner"> Indent</div>
			</div>
		);
	}
}

  
export default Indent;